import React from "react";
import { useParams, useNavigate } from "react-router";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import { useToast } from "../../Hooks/useToast";

import AlternativeHeader from "../../Components/Headres/Alternative_Header";
import FromikTextField from "../../Components/Utils/Formik_Texfiled";
import CustomButton from "../../Components/Utils/Custom_Btn";
import FormikCheckbox from "../../Components/Utils/Formik_CheckBox";

import Grid from "@mui/material/Grid";
import  Box  from "@mui/material/Box";
import Divider from "@mui/material/Divider";

import { fetchgetUserById } from "../../Redux/Users_Slice";
import { updateUser } from "../../Apis/Users/Users";


const UpdataUser = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.Users);
  const navigate = useNavigate();
  const { toastSuccess, toastError } = useToast();

  useEffect(() => {
    if (param.id) {
      dispatch(fetchgetUserById(param.id));
    }
  }, [param.id]);

  useEffect(() => {
    if (param.id && data.data.data) {
      formik.setValues({
        firstName: data.data.data.firstName || "",
        lastName: data.data.data.lastName || "",
        address: data.data.data.address || "",
        phoneNumber: data.data.data.phoneNumber|| "",
        email: data.data.data.email || "",
        address:data.data.data.address || "",
        isBadUser: data.data.data.isBadUser === true || data.data.data.isBadUser === "true"
      });
    }
  }, [param.id, data.data.data]);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      address:"",
      phoneNumber:"",
      isBadUser: false,
    },
    onSubmit: async (values) => {
      if (param.id) {
        try {
          const data = await updateUser(param.id, {
            ...values,
            isBadUser: values.isBadUser 
          });
    
          if (data.status === 200) {
            toastSuccess("Kunde erfolgreich aktualisiert!");
            navigate('/Kunden');
          } else {
            toastError("Aktualisierung fehlgeschlagen. Bitte versuchen Sie es erneut.");
          }
        } catch (error) {
          console.error("Update error:", error);
          toastError("Ein Fehler ist beim Aktualisieren des Kunden aufgetreten.");
        }
      }
    },    
  });


  return (
    <>
      <AlternativeHeader
        onPrevious={() => navigate("/Kunden")}
        title="Fügen Sie einen Kunden hinzu"
      />
      <Box mt={5}>
        <Grid container spacing={4}>
          <Grid size={5}>
            <FromikTextField
              formik={formik}
              name="firstName"
              label="Vorname"
              placeholder="e.g. John"
            />
          </Grid>
          <Grid size={5}>
            <FromikTextField
              formik={formik}
              name="lastName"
              label="Nachname"
            />
          </Grid>
          <Grid size={5}>
            <FromikTextField
              formik={formik}
              name="phoneNumber"
              label="Telefonnummer"
            />
          </Grid>
          <Grid size={5}>
            <FromikTextField
              formik={formik}
              name="email"
              label="Email"
            />
          </Grid>
          <Grid size={5}>
            <FromikTextField
              formik={formik}
              name="address"
              label="Adresse"
            />
          </Grid>
          <Grid size={5}>
            <Box mt={5}>
              <FormikCheckbox
                formik={formik}
                name="isBadUser"
                label="Rote Karte"
              />
              </Box>
          </Grid>
        </Grid>
      </Box>
      <Divider
        sx={{
          marginTop: 3,
          borderColor: "#000000",
        }}
      />
      <Box mt={2} display="flex" justifyContent="end">
        <CustomButton onNavigate={formik.handleSubmit} title="speichern" />
      </Box>
    </>
  );
};

export default UpdataUser;
